var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProfileImg5(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_856_6990)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_856_6990",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 24
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.7483,
    cy: 12,
    r: 12,
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_856_6990)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-6.17281 19.2262C-6.93113 19.3585 -7.58758 18.6387 -7.38613 17.8958C-5.69667 11.6651 -4.50514 2.9525 0.167442 -1.30901C4.84002 -5.57051 13.625 -5.95683 19.9845 -7.06691C20.7428 -7.19928 21.3993 -6.47949 21.1978 -5.73652C19.5084 0.494206 18.3168 9.20677 13.6443 13.4683C8.97167 17.7298 0.186646 18.1161 -6.17281 19.2262Z",
    fill: "#E2BBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.7782 30.3486C38.9105 31.1069 38.1908 31.7634 37.4478 31.5619C31.217 29.8725 22.5045 28.681 18.2429 24.0084C13.9814 19.3359 13.5951 10.5509 12.4849 4.19143C12.3526 3.43311 13.0724 2.77666 13.8153 2.97812C20.0461 4.66754 28.7587 5.85906 33.0202 10.5316C37.2817 15.2042 37.6681 23.9892 38.7782 30.3486Z",
    fill: "#FFD6F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0182 12.5556C15.5105 11.5746 14.2904 11.1787 13.4072 11.8421C11.4257 13.3307 9.93946 15.408 9.17872 17.8011C8.21455 20.8341 8.49472 24.1259 9.95759 26.9523C11.4205 29.7787 13.9462 31.9083 16.9792 32.8724C19.3723 33.6332 21.9264 33.6193 24.286 32.861C25.3376 32.5231 25.7189 31.2983 25.2112 30.3174L20.6147 21.4365L16.0182 12.5556Z",
    fill: "#267CBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9207 14.4803C29.2928 14.8884 29.9288 14.9202 30.3045 14.5154C31.6842 13.0287 32.6684 11.212 33.1577 9.23256C33.7273 6.92856 33.6008 4.5074 32.7943 2.27527C31.9878 0.0431389 30.5376 -1.89972 28.6269 -3.30762C26.7162 -4.71552 24.4309 -5.52523 22.06 -5.63435C19.6892 -5.74347 17.3392 -5.1471 15.3073 -3.92066C13.2753 -2.69422 11.6527 -0.89279 10.6446 1.25583C9.63651 3.40444 9.28819 5.80374 9.6437 8.15032C9.94914 10.1664 10.7623 12.0657 11.9996 13.6729C12.3365 14.1105 12.9727 14.1373 13.3808 13.7651L20.7695 7.02669C21.1775 6.65454 21.81 6.68365 22.1822 7.09171L28.9207 14.4803Z",
    fill: "#CFE5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.98209 11.3172C-3.28438 11.6027 -4.12249 12.8968 -3.68227 14.1552C-3.08382 15.866 -2.25435 17.491 -1.21403 18.9842C0.287365 21.1392 2.19852 22.9774 4.4103 24.3937C6.62209 25.8101 9.09121 26.777 11.6767 27.2392C13.4681 27.5594 15.2911 27.633 17.0954 27.4609C18.4225 27.3343 19.2474 26.0317 18.9619 24.7294L15.7129 9.90942C15.4274 8.60714 14.1403 7.78286 12.838 8.06834L-1.98209 11.3172Z",
    fill: "#66B1F4"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_856_6990"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.748291)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileImg5);
export default __webpack_public_path__ + "static/media/profileImg5.61d7fd5d209cda52ce7b04e88f1451f9.svg";
export { ForwardRef as ReactComponent };